export enum AligningType {
    NON_ALIGNED = 0,
    ALIGNED,
    NA,
}
